import { navigationStore } from '../../bridge/navigationStore';

// @ngInject
const userSettingsResolve = ($q) => $q.when({});

// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('main', {
    parent: 'app',
    url: '',
    abstract: true,
    views: {
      'app-content': {
        templateUrl: 'main/main.tpl.html',
        controller: 'MainController as vm',
      },
    },
    data: { claims: ['user'] },
    resolve: {
      userSettings: userSettingsResolve,
    },
  });
};

class MainController {
  constructor(
    $rootScope,
    $scope,
    appSettings,
    userSettings,
    currentUser,
    DS,
    $state,
    AuthService,
  ) {
    'ngInject';

    $rootScope.appSettings = appSettings;
    $rootScope.userSettings = userSettings;
    $rootScope.currentUser = currentUser;
    this.$scope = $scope;
    this.$state = $state;
    this.AuthService = AuthService;
    this.unconfirmedTasks = 0;
    this.DS = DS;
    this.currentUser = currentUser;
    this.updateNavigationState();
    this.setWatchers();
  }

  setWatchers() {
    this.$scope.$watch(() => {
      return this.DS.lastModified('task');
    });

    this.$scope.$on('$stateChangeSuccess', () => {
      this.updateNavigationState();
    });
  }

  updateNavigationState() {
    const activeState = this.$state.current.name;
    navigationStore.setActiveState(activeState);

    if (!/^(customer|concept|article|variant)(\.|$)/.test(activeState)) {
      navigationStore.setContext(null);
    }
  }
}

angular
  .module('app.main', [
    'main.customers',
    'main.customerDirectory',
    'main.customer',
    'main.concept',
    'main.article',
    'main.suppliers',
    'main.supplier',
    'main.users',
    'main.configuration',
    'main.tasks',
    'main.archive',
    'main.searcharticles',
    'main.shipments',
    'main.vdcPricing',
    'main.tags',
    'main.jobs',
  ])
  .config(config)
  .controller('MainController', MainController);
